export default "__VITE_ASSET__C4f5nA7L__"